var discountUTM = [
    {
        code: 'AU20GGFF',
        discount: 20,
        type:null, 
        ads:'google'
    },
    {
        code: 'DC20GG',
        discount: 20,
        type:['Hawaiian Shirt','Wine Tumbler','Tumbler Cup','Skinny Tumbler','Lowball Tumbler','Engraved 40oz Tumbler','Bullet Tumbler','Acrylic Insulated Tumbler With Straw',
            '40oz Tumbler','30oz Tumbler With Handle','30oz Curved Tumbler','14OZ Engraved Tumbler','Acrylic Car Vent Clip','2 Layered Wooden Car Visor Clip','Wooden Car Visor Clip',
            'Wooden Car Visor Clip And Acrylic Keychain','Wooden Car Visor Clip and Keychain','Wooden Card With Pop Out Ornament','Leather Car Visor Organizer','Memorial Charm Car Ornament',
            'Car Sunshade','Car Side Window Sun Shade','Car Headrest Covers','Leather Journal','Window Hanging Suncatcher Ornament','Book Page Holder','Resin Book Page Holder',
            'Leather Magnetic Bookmark','Wooden Family Puzzle','Pillow','Tote Bag','Cosmetic Bag','Leather Long Wallet','Leather Bag','Leather Wide Open Makeup Bag',
            'Bible Cover','Mug','Engraved Whiskey Glass','Classic Cap','Beer Glass','Whiskey Glass','Whiskey Glass With Photo','Distressed Denim Cap','Embroidered Cap',
            'Sweatpants','Hanging Toiletry Bag','Leather Keychain','Memorial Keychain','Acrylic Keychain','Keychain','Engraved Stainless Steel Keychain','Satin Pajama Pants','Lounge Pants',
            'Fleece Pajama Pants','Flare Leggings','Leggings','Blankets', 'Spare Tire Cover', 'Flag', 'Car Seat Cover', 'Shirt', 'Back Printed Shirt','Leather Toiletry Bag','Engraved Leather Belt'
        ],
        ads:'google'
    },
    {
        code: 'DCGG30',
        discount: 30,
        type: ['Doormat','Custom Shaped Metal Sign','Metal Sign','Acrylic Garden Stake','Printed Metal Garden Stake','Metal Garden Stake','Garden Stone'],
        ads:'google'
    },
    {
        code: 'UK2026',
        discount: 20,
        type:null, 
        ads:'google'
    },
    {
        code: 'BF50FB',
        discount: 50,
        collection:['Personalized Blanket'],
        ads:'meta'
    },
    {
        code: 'BF42FB',
        discount: 42,
        collection:['Holiday Ornaments'],
        ads:'meta'
    },
    {
        code: 'BF53FB',
        discount: 53,
        collection:['Holiday Ornaments'],
        ads:'meta',
        isCustom:true,
        items:5,
        price:8
    },
    {
        code: 'PONM',
        discount: 65,
        collection:['Holiday Ornaments'],
        ads:'meta',
        items:10,
        price:6
    },
    {
        code: 'BF30FB',
        discount: 30,
        collection:null,
        ads:'meta'
    },
    {
        code: 'BFCM',
        discount: 30,
        collection:null,
        ads:'meta'
    },
    {
        code: 'BF20FB',
        discount: 20,
        collection:null,
        ads:'meta'
    },
    {
        code: 'CS25',
        discount: 25,
        collection:null,
        ads:'meta'
    },
    {
        code: 'BF25FB',
        discount: 25,
        collection:null,
        ads:'meta'
    },
    {
        code: 'BF51FB',
        discount: 51,
        collection:null,
        ads:'meta'
    },
    {
        code: 'MTS34',
        discount: 34,
        collection:['Metal Sign'],
        ads:'meta'
    },
    {
        code: 'HT30',
        discount: 30,
        collection:null,
        ads:'meta'
    },
    {
        code: 'TP20',
        discount: 20,
        collection:null,
        ads:'meta'
    },
    {
        code: 'HB10',
        discount: 10,
        collection:null,
        ads:'meta'
    },
]
const CAMPAIGN_ADS_GOOGLE =[
    21047190149,
    23297977638,
    23277787320,
    20877453289,
    23357105932,
    23357123020,
    20839862361,
    23364328009,
    23256396653
]
const TYPE_NOT_BFCM = ['Mug', 'Shirt With Design On Sleeve', 'Shirt', 'Custom Print Hoodie','Comfort Tee','Poster','Gift Card','Tumbler Cup','Jewelry Dish','Square Jewelry Dish_FULL'];
const PRODUCT_ID_NOT_BFCM = [8653360660636,8649616261276]
const PRODUCT_ID_BFCM = [
    8572847030428,
    8652684689564,
    8650815635612,
    8568679530652,
    8307431800988,
    8658929254556,
    8604791963804,
    8653380976796, 
    8291106750620,
    8638111744156,
    8667892580508,
    8681830219932,
    8552602206364,
    8559590506652,
    8670292770972,
    8638358749340,
    8643326378140,
    8648045756572,
    7905587298460,
    8662356131996,
    8668904947868,
    8677407260828,
    8668909011100,
    8668900851868,
    7905764311196,
    8682060284060,
    8667892580508,
    8653306429596,
    8292586127516,
    8305064050844
];
const svgCopy = `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 1024 1024">
                      <path fill="#fff" d="M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64h64z"></path>
                      <path fill="#fff" d="M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64H384zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64z"></path>
                    </svg>`;

function getCurrentLATime() {
    const now = new Date();
    // Convert current time to America/Los_Angeles timezone
    const laTimeString = now.toLocaleString("en-US", {
        timeZone: "America/Los_Angeles",
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false
    });

    // Parse lại thành date object
    const [month, day, year] = laTimeString.split(',')[0].split('/');
    const [hour, minute, second] = laTimeString.split(',')[1].split(':');

    return new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day),
        parseInt(hour),
        parseInt(minute),
        parseInt(second)
    ).getTime();
}
function getNextMidnightLATime() {
    const now = getCurrentLATime();

    const nextMidnight = new Date(now);
    nextMidnight.setDate(nextMidnight.getDate() + 1);
    nextMidnight.setHours(0, 0, 0, 0);

    return nextMidnight.getTime();
}

function countdownUTM() {
    let timer;
    let targetTime = getNextMidnightLATime();

    function updateCountdown() {
        const now = getCurrentLATime();
        let totalSeconds = Math.floor((targetTime - now) / 1000);

        if (totalSeconds <= 0) {
            targetTime = getNextMidnightLATime();
            totalSeconds = Math.floor((targetTime - now) / 1000);
        }

        const hours = Math.floor((totalSeconds / (60 * 60)) % 24);
        const minutes = Math.floor((totalSeconds / 60) % 60);
        const seconds = Math.floor((totalSeconds) % 60);

        $("#h").text(String(hours).padStart(2, "0"));
        $("#m").text(String(minutes).padStart(2, "0"));
        $("#s").text(String(seconds).padStart(2, "0"));
    }

    updateCountdown();
    timer = setInterval(updateCountdown, 1000);
}

function showDiscountHeader(code, discount = 0){
  const COUNTRY_CODE = $('body').attr('country-code');
  if(COUNTRY_CODE == 'GB'){
    $('.header-wrapper').prepend(`
          <div class="promotion-box custom-bfcm custom-uk">
            <div class="page-width">
             <p class="sub-free-ship">Free shipping on all orders</p>
             <div class="promotion-box-content">
              <div id="countdown"><span id="h">00</span> :<span id="m">39</span> :<span id="s">59</span></div>
              <div class="box-content">
                <p class="redirect-collection"><strong>${discount}% </strong>off with <strong>${code}</strong> </p> 
                <button class='copy-discount'>${svgCopy}</button>
                </div>
              </div>
            </div>  
            <div id="toast" class="toast">Code copied!</div>             
          </div>
    `);
    return
  }
  $('.header-wrapper').prepend(`
          <div class="promotion-box custom-bfcm">
            <div class="page-width">
             <div class="promotion-box-content">
              <div id="countdown"><span id="h">00</span> :<span id="m">39</span> :<span id="s">59</span></div>
              <p class="redirect-collection">Holiday Sale: <strong>${discount}% OFF</strong>${code=='MHS20'?' Sitewide':''}</p>
              <div class="box-code-bfcm">
                Use code: <strong>${code}</strong> 
                <button class='copy-discount'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 1024 1024">
                    <path fill="#fff" d="M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64h64z"/>
                    <path fill="#fff" d="M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64H384zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64z"/>
                  </svg>
                </button>
              </div>
             </div>
            </div>  
            <div id="toast" class="toast">Code copied!</div>             
          </div>
    `);
}

function showDiscountOrnamentHeader(code, price = 0, items = 5){
  const COUNTRY_CODE = $('body').attr('country-code');
  $('.header-wrapper').prepend(`
          <div class="promotion-box custom-bfcm-ornament">
            <div class="page-width">
             <div class="promotion-box-content">  
              ${COUNTRY_CODE == 'GB' ? `<p class="sub-free-ship">Free shipping on all orders</p>`:''}
              <div class="box-code-bfcm-ornament">
                <p>Buy ${items}+, from <strong class="price-sale-utm">$${price}</strong> each with <strong>${code}</strong></p>
                <button class='copy-discount' data-code='${code}'>${svgCopy}</button>
              </div>
             </div>
            </div>  
            <div id="toast" class="toast">Code copied!</div>             
          </div>
    `);
}